<template>
  <div>
    <div class="case-references py-1 px-3" v-if="refs && refs.length > 0">
      <template v-for="ref in refs">
        <div :key="ref.id" v-if="caseById(ref.referenced_patient_case_id)" class="mb-3 shadow-sm">
          <HistoryItem
            :item="caseById(ref.referenced_patient_case_id)"
            :activeCaseId="value"
          ></HistoryItem>
        </div>
      </template>
    </div>
    <div v-else class="alert alert-secondary mt-3">
       ჩანაწერები არ არის მიმაგრებული
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import HistoryItem from "@/components/Panel/Doctor/PatientHistoryItem.vue";
export default {
  components: {
    HistoryItem
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      authToken: "auth/token",
      caseReferences: "pcase/references",
      caseById: "pcase/byId"
    }),
    refs() {
      return this.caseReferences(this.value);
    }
  }
};
</script>
